/* eslint-disable eag/match-named-export */
import {z} from '@hono/zod-openapi';

export const sendEventAsS2sBody = z.object({
  content: z.string().min(1).max(2000).openapi({
    description: 'Event content (1-2000 characters)',
    example: 'Hello, I need help with my order.',
  }),
  userId: z.string().uuid().openapi({
    description: 'ID of the user sending the event',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});

export type SendEventAsS2sBody = z.infer<typeof sendEventAsS2sBody>;
